import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import InputType from '../../../shared/enums/input-type.enums';
import { ButtonType } from '../../../shared/enums/button-type.enums';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InputComponent } from '../../atoms/input/input.component';

import { IconComponent } from '../../atoms/icon/icon.component';
import { Colors } from '../../../shared/enums/shared.enums';

@Component({
  selector: 'hdi-search',
  standalone: true,
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
  imports: [CommonModule, InputComponent, IconComponent, FontAwesomeModule],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class SearchComponent {
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() placeholder: string = '';
  @Input() inpage: boolean = false;
  @Input() inpageCTA: boolean = false;
  @Input() hasError: boolean = false;
  @Output() handleInputChange = new EventEmitter<string>();
  @Output() handleClearInput = new EventEmitter<void>();
  @Output() handleInputSubmit = new EventEmitter<void>();
  @ViewChild('inputLabel') inputLabel: ElementRef = {} as ElementRef;
  @ViewChild(InputComponent, { static: false }) hdiInput: InputComponent =
    {} as InputComponent;

  showCloseIcon: boolean = false;

  inputType = InputType.Search;

  @Input() iconColor: Colors = Colors.BLACK;
  @Input() iconColorError: Colors = Colors.ERROR;
  @Input() buttonIconColor: Colors = Colors.BLACK;
  @Input() buttonIconColorError: Colors = Colors.ERROR;
  buttonType = ButtonType.SEARCH_NO_BG;

  inputChange(event: string) {
    if (event.trim().length > 0) {
      this.showCloseIcon = true;
    } else {
      this.showCloseIcon = false;
    }
    this.handleInputChange.emit(event);
  }
  clearInput() {
    const input = this.inputLabel.nativeElement.children[0].children[0];
    input.value = '';
    this.showCloseIcon = false;
    this.handleInputSubmit.emit();
    this.handleClearInput.emit();
  }

  get inputElement(): HTMLInputElement {
    if (this.hdiInput?.nativeInput) {
      return this.hdiInput.nativeInput.nativeElement;
    }
    throw new Error('Input element not resolved');
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.clearInput();
    }
  }
}
